import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {CalendarModule} from 'primeng/primeng';
import {Routes, RouterModule,PreloadAllModules} from '@angular/router';
import {CasesRoutingModule} from './cases-routing.module';
import {CaseComponent} from './components/case.component';
import {SettingsComponent} from './components/settings.component';
import {DetailComponent} from './components/detail.component';
import {CaseCrudComponent} from './components/case-crud.component';
import {CasesImportComponent} from './components/cases-import.component';
import {CasesExportComponent} from './components/cases-export.component';
import {SortablejsModule} from 'angular-sortablejs';
import {GlobalDataService} from '../housekeeping/services/global-data.service';
import {CaseService} from '../cases/services/case.service';
import {RoleGuardService} from '../../role-guard.service';
import { HousekeepingModule } from '../../../app/modules/housekeeping/housekeeping.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

const routes: Routes = [
    {path: 'cases', component: CaseComponent, canActivate: [RoleGuardService]},
    {path: 'cases/settings', component: SettingsComponent, canActivate: [RoleGuardService]},
    {path: 'cases/detail/:id', component: DetailComponent, canActivate: [RoleGuardService]},
    {path: 'cases/create', component: CaseCrudComponent, canActivate: [RoleGuardService]},
    {path: 'cases/edit/:id', component: CaseCrudComponent, canActivate: [RoleGuardService]},
    {path: 'cases/export', component: CasesExportComponent, canActivate: [RoleGuardService]},
    {path: 'cases/import', component: CasesImportComponent, canActivate: [RoleGuardService]},

];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CalendarModule,
        CasesRoutingModule,
        HousekeepingModule,
        RouterModule.forRoot(routes,
          {
            useHash: false,
            preloadingStrategy: PreloadAllModules
          }),
        SortablejsModule.forRoot({
            animation: 200,
        }),
        NgxPaginationModule,
        NgMultiSelectDropDownModule.forRoot(),
    ],
    exports: [RouterModule],
    providers: [GlobalDataService, CaseService],
    declarations: [CaseComponent, SettingsComponent, DetailComponent, CaseCrudComponent, CasesImportComponent, CasesExportComponent]
})
export class CasesModule {}



// WEBPACK FOOTER //
// ./src/app/modules/cases/cases.module.ts